import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-view-grid-icon',
  templateUrl: 'view-grid-icon.component.html'
})
export class ViewGridIconComponent {
  constructor() {}
}
